import filingPaths from "./paths.ts";
import {RouteObject} from "react-router-dom";
import AlertRulesView from "../alerts/views/AlertRulesView.tsx";

export const filingsRoutes: RouteObject[] = [

];